import { SignMethodEnum, SigningStatusEnum } from '@modules/husleie-framework/src/types/Signing.entity';
import type SigningState from '@modules/store/signing/types/SigningState.entity';

export const state: SigningState = {
  loading: null,
  signingLoaded: false,
  signersLoaded: false,
  apiError: false,
  signing: {
    method: SignMethodEnum.DIGITAL,
    uuid: '',
    signerUuid: '',
    status: SigningStatusEnum.OPEN,
    signers: [],
    signersStatus: {
      landlord: undefined,
      tenant: undefined,
    },
    preview: {},
    termsAndConditions: {
      generalTerms: false,
      privacyStatement: false,
      additionalTerms: false,
    },
    nect: {
      signingId: undefined,
      createSigningData: undefined,
      signers: [],
    },
  },
  session: {
    type: undefined,
  },
};
